import { render } from "./WhyThisMattersSection.vue?vue&type=template&id=1e0115aa&scoped=true"
const script = {}

import "./WhyThisMattersSection.vue?vue&type=style&index=0&id=1e0115aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0115aa"]])

export default __exports__